var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame41({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5319 8.33338L12.1986 5.00005M2.61523 17.9167L5.43554 17.6033C5.78012 17.5651 5.9524 17.5459 6.11344 17.4938C6.25631 17.4475 6.39227 17.3822 6.51764 17.2995C6.65895 17.2063 6.78152 17.0838 7.02667 16.8386L18.0319 5.83338C18.9524 4.91291 18.9524 3.42052 18.0319 2.50005C17.1114 1.57957 15.6191 1.57957 14.6986 2.50005L3.69334 13.5053C3.44819 13.7504 3.32561 13.873 3.23243 14.0143C3.14976 14.1397 3.08441 14.2756 3.03816 14.4185C2.98603 14.5795 2.96689 14.7518 2.9286 15.0964L2.61523 17.9167Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame41);
export default __webpack_public_path__ + "static/media/Frame (41).a9a39cd80d5b1318635d96219004c83f.svg";
export { ForwardRef as ReactComponent };